// import moment from "moment";
function isNumber(value) {
  return !isNaN(value);
}
export const changeState = (value, static_threshold) => {
  // let diff = moment().diff(moment(ts), "minute") //判断测点3分钟内是否更新
  // if (value == "" || value === null || diff > 3) {
  //   return "unknown";
  // }
  // if(static_threshold.operationThresholdLow>static_threshold.standardThresholdLow&&static_threshold.operationThresholdHigh>static_threshold.standardThresholdHigh){
    // !(isNaN(static_threshold.operationThresholdHigh) &&
    // isNaN(static_threshold.operationThresholdLow) &&
    // isNaN(static_threshold.standardThresholdLow) &&
    // isNaN(static_threshold.standardThresholdHigh))||
    if(static_threshold.standardThresholdLow<static_threshold.operationThresholdLow||static_threshold.standardThresholdHigh>static_threshold.operationThresholdHigh){
      return "unknown";
      }
  if (
    isNumber(value) &&
    isNumber(static_threshold.operationThresholdHigh) &&
      isNumber(static_threshold.operationThresholdLow) &&
        isNumber(static_threshold.standardThresholdLow) &&
          isNumber(static_threshold.standardThresholdHigh)
  ) {
    if (
      value >= static_threshold.operationThresholdHigh ||
      value <= static_threshold.operationThresholdLow
    ) {
      return "error";
    } else if (
      static_threshold.standardThresholdLow <= value &&
      value <= static_threshold.standardThresholdHigh
    ) {
      return "health";
    } else if (
      static_threshold.operationThresholdLow <
        value <
        static_threshold.standardThresholdLow ||
      static_threshold.standardThresholdHigh <
        value <
        static_threshold.operationThresholdHigh
    ) {
      return "sub-health";
    } else {
      return "unknown";
    }
  } else {
    return "unknown";
  }

  // }
};